import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_have_legally_required_firefighting_equipment'

export const dataPointDefinition = {
  retracedId: 'does_facility_have_legally_required_firefighting_equipment',
  name: 'Does the facility have legally required firefighting equipment?',
  description:
    'Examples of firefighting equipment include fire extinguishers, fire hoses, sprinkler system, and hydrant system. ',
  meta: {
    slcpMeta: {
      key: 'hs-20--4',
      number: 'HS-EME-8',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-20--4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29230,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
